/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

/**
 * The usage permission this entry describes.
 */
export type VehicleFilterPermissionSettingDtoPermission = typeof VehicleFilterPermissionSettingDtoPermission[keyof typeof VehicleFilterPermissionSettingDtoPermission];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VehicleFilterPermissionSettingDtoPermission = {
  PETS: 'PETS',
  ABROAD: 'ABROAD',
  KIDS: 'KIDS',
} as const;
